import React from 'react';
import { Language } from '../../types';
import Icon from '../../utils/icons';
import './Languages.css';

const levelIcon: Record<string, React.ReactNode> = {
    'Native':         <Icon name="star" size={20} />,
    'Professional':   <Icon name="briefcase" size={20} />,
    'Conversational': <Icon name="chat" size={20} />,
    'Basic':          <Icon name="book" size={20} />,
};

const levelWidth: Record<string, string> = {
    'Native':         '100%',
    'Professional':    '80%',
    'Conversational':  '55%',
    'Basic':           '30%',
};

interface Props {
    languages: Language[];
}

const Languages: React.FC<Props> = ({ languages }) => (
    <div className="languages-grid">
        {languages.map((lang, index) => {
            const name  = lang.name;
            const level = lang.level;
            const width = levelWidth[level] || '50%';
            return (
                <div key={index} className="lang-card">
                    <div className="lang-header">
                        <span className="lang-emoji">{levelIcon[level] ?? <Icon name="chat" size={20} />}</span>
                        <div>
                            <div className="lang-name">{name}</div>
                            {level && <div className="lang-level">{level}</div>}
                        </div>
                    </div>
                    {level && (
                        <div className="lang-bar-track">
                            <div className="lang-bar-fill" style={{ width }} />
                        </div>
                    )}
                </div>
            );
        })}
    </div>
);

export default React.memo(Languages);
